import { createContext, useContext } from "react";

/**
 * SessionContext - the current in-meeting session as seen by the viewer: identity
 * (role, meetingUuid, meetingId, rtmsStreamId), the viewer's alias, and the live RTMS status
 * (rtmsStartTime, rtmsRequesterName, isRtmsStartedByOther).
 *
 * Home owns these values and provides them to its active-session subtree, so SessionView and its
 * descendants read them via useSession() instead of drilling props. Non-legacy Home subtree only;
 * legacy and transcript paths keep their props. `meetingUuid` is the canonical lowercase name
 * (Home maps its local `meetingUUID` at the provider).
 */
const SessionContext = createContext({
  role: null,
  meetingUuid: null,
  meetingId: null,
  rtmsStreamId: null,
  alias: null,
  rtmsStartTime: null,
  rtmsRequesterName: null,
  isRtmsStartedByOther: false,
});

export const useSession = () => useContext(SessionContext);

export const SessionProvider = ({ value, children }) => (
  <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
);
